import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";
import UI from "@mile-meeting/mile-ui";
const UserInput = ({ onChangeValue, value = [] }: { onChangeValue?: (value: string[]) => void; value?: string[] }) => {
  const [userString, setUserString] = useState<string>("");
  const chipRefs = useRef<(HTMLDivElement | null)[]>([]); // 칩의 참조를 담을 배열
  const inputRefs = useRef<HTMLInputElement | null>(null); // 입력창의 참조를 담을 배열

  const onHandleDeleteChip = (index: number) => {
    const newUserList = value.filter((_, i) => i !== index);
    onChangeValue?.(newUserList);
  };

  useEffect(() => {
    chipRefs.current = chipRefs.current.filter((chip) => chip);
  }, [value]);

  const inputHandleKeyDown = (e: { currentTarget: any; key: any }) => {
    switch (e.key) {
      case "Enter":
      case " ":
        const enteredUser = userString.trim().split(/[\s,]+/);
        onChangeValue?.([...value, ...enteredUser.filter((user) => user !== "")]);
        setUserString("");

        break;
      case "ArrowLeft":
        if (e.currentTarget.selectionStart === 0) {
          const lastChip = chipRefs.current[value.length - 1];
          lastChip?.focus();
        }
        break;
      default:
        break;
    }
  };

  const chipHandleKeyDown = (e: { key: any }, index: number) => {
    switch (e.key) {
      case "ArrowLeft":
        if (index > 0) {
          chipRefs.current[index - 1]?.focus();
        } else {
          inputRefs.current?.focus();
        }
        break;
      case "ArrowRight":
        if (index < chipRefs.current.length - 1) {
          setTimeout(() => {
            chipRefs.current[index + 1]?.focus();
          }, 0);
        } else {
          inputRefs.current?.focus();
        }
        break;
      case "Backspace":
        if (index >= 0) {
          onHandleDeleteChip(index);
          if (index > 0) {
            setTimeout(() => {
              chipRefs.current[index - 1]?.focus();
            }, 0);
          }
        } else if (index === 0 && chipRefs.current.length > 1) {
          setTimeout(() => {
            chipRefs.current[1]?.focus();
          }, 0);
        } else {
          inputRefs.current?.focus();
        }
        break;
      default:
        break;
    }
  };

  return (
    <InputContainer>
      <div style={{ paddingLeft: "16px", display: "flex", gap: "6px" }}>
        {value.map((user, index) => (
          <ChipContainer
            key={index}
            onKeyDown={(e) => chipHandleKeyDown(e, index)}
            ref={(ref) => (chipRefs.current[index] = ref)}
            tabIndex={0}
          >
            <div className="interaction" />
            <UI.Chip.Contained
              rightIcon="x"
              showRightIcon
              title={user}
              type="secondary"
              onClick={() => onHandleDeleteChip(index)}
            />
          </ChipContainer>
        ))}
      </div>
      <Input
        onBlur={() => {
          const enteredUser = userString.trim().split(" ");
          onChangeValue?.([...value, ...enteredUser.filter((user) => user !== "")]);
          setUserString("");
        }}
        ref={inputRefs}
        onKeyDown={inputHandleKeyDown}
        value={userString}
        onChange={(e) => {
          setUserString(e.target.value);
        }}
      ></Input>
    </InputContainer>
  );
};

export default UserInput;

const InputContainer = styled.button`
  display: flex;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--alias-color-line-normal);
  background-color: var(--alias-color-background-normal-normal);
  width: 100%;

  align-items: center;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden;

  &:focus-within {
    border: 1px solid var(--global-color-coolneutral-70);
    outline: none;
  }

  :has(::-webkit-scrollbar) {
    height: 68px;
  }
`;

const Input = styled.input`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.16px;
  padding: 0 16px 0 0;
  box-sizing: border-box;
  height: 48px;
  flex: 1;
  width: max-content;
  color: var(--alias-color-label-normal);
  font-family: Pretendard;
  border: none;

  &:focus {
    outline: none;
  }
`;

const ChipContainer = styled.div`
  &:focus {
    outline: none;
    .interaction {
      background-color: var(--alias-color-label-normal);
      opacity: 0.08;
    }
  }
`;
